import { useQuery } from '@tanstack/react-query'
import { onboardingService } from './onboarding.service'

export function useOnboardingStatus(enabled: boolean = true) {
  return useQuery({
    queryKey: ['onboarding', 'status'],
    queryFn: () => onboardingService.getStatus(),
    staleTime: Infinity,
    enabled,
  })
}
